<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">Purchase Membership</h2>
      <p class="text-muted mb-0">Select a membership plan to purchase</p>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    @if (loading) {
      <div class="text-center py-5">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    } @else {
      @if (plans.length === 0) {
        <div class="alert alert-info">
          No membership plans available at this time.
        </div>
      } @else {
        <div class="row g-4">
          @for (plan of plans; track plan.plan_id) {
            <div class="col-12">
              <div
                class="card cursor-pointer"
                [class.border-primary]="selectedPlan?.plan_id === plan.plan_id"
                (click)="selectPlan(plan)">
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-start">
                    <div class="flex-grow-1">
                      <h4 class="mb-2">{{ plan.name }}</h4>
                      <p class="text-muted mb-2">
                        <i class="fa fa-tag me-2"></i>{{ plan.code }}
                      </p>
                      <p class="mb-2">
                        <span class="badge" [class.badge-primary]="plan.coverage === 'individual'" [class.badge-success]="plan.coverage === 'family'">
                          {{ plan.coverage | titlecase }}
                        </span>
                        <span class="badge badge-secondary ms-2">{{ plan.billing_cycle | titlecase }}</span>
                      </p>
                      @if (plan.max_children) {
                        <p class="text-muted mb-0">
                          <i class="fa fa-users me-2"></i>Max children: {{ plan.max_children }}
                        </p>
                      }
                    </div>
                    <div class="text-end">
                      <h3 class="mb-0 text-primary">{{ formatPrice(plan.price_cents) }} kr</h3>
                      <small class="text-muted">per {{ plan.billing_cycle }}</small>
                    </div>
                  </div>
                  @if (selectedPlan?.plan_id === plan.plan_id) {
                    <div class="mt-3">
                      <i class="fa fa-check-circle text-primary"></i>
                      <span class="text-primary ms-2">Selected</span>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }
    }
  </div>

  <div class="modal-footer">
    <div class="row w-100">
      <div class="col-12 d-flex justify-content-end gap-2">
        <app-button
          [variant]="'neutral'"
          [label]="'Cancel'"
          (clicked)="close()"
        />
        <app-button
          [variant]="'primary'"
          [label]="'Purchase'"
          [iconClass]="'fa fa-shopping-cart'"
          [disabled]="!selectedPlan"
          [loading]="purchasing"
          (clicked)="purchaseMembership()"
        />
      </div>
    </div>
  </div>
</div>
